module.exports = __webpack_public_path__ + "media/images/cogniclick-grey-a6bb2acf1e2be0f9255ffb7f9b333380.svg";